export function humanizeNumber(num) {
  if (!num) return "0";
  num = parseFloat(num);
  num = Math.round(num * 100) / 100;
  num = num.toString();
  while (true) {
    var n2 = num.replace(/(\d)(\d{3})($|,|\.)/g, "$1,$2$3");
    if (num == n2) break;
    num = n2;
  }
  return num;
}
